import { useState, useEffect } from "react"
import { useDispatch } from "react-redux"
import { addNewOrderMarkers, removeMarker } from "../../../reducers/mapMarkerSlice"
import { stripIdFromStaffName } from "../../../utilities/common"
import { usePrevious } from "../../../utilities/hooks"
import { addSelectedOrder, removeSelectedOrders, addSelectedAccounts } from "../../../reducers/uiSlice"
import { Typography, Badge, makeStyles } from "@material-ui/core"
import _ from 'lodash'

const useStyles = makeStyles((theme)=> ({
    accordianSummaryStyle: {
        marginLeft: 20,
        width: 600,
        display: 'flex',
        alignItems: 'center'
    },
    badgeStyle: {
        marginLeft: 12
    }
}))
function SelectableOrderInfo(props){
    const classes = useStyles()
    let {data, areaExpanded} = props
    const dispatch = useDispatch();

    const [checked, setChecked] = useState([]);

    let prevChecked = usePrevious(checked)
    let districtOrders = filterDistrictOrders(props.staffOrders, props.filter)

    useEffect(() => {
        let newChecked = _.difference(checked, prevChecked)
        let removeChecked = _.difference(prevChecked, checked)
        
        if(newChecked.length > 0){
            dispatch(addSelectedOrder(newChecked))
            dispatch(addSelectedAccounts([data.id]))
            let orderArray = _.flatten(_.values(districtOrders))
            let orders = _.intersectionWith(orderArray, newChecked, (o, id)=> o.order_id === id)
            dispatch(addNewOrderMarkers(orders))
        }

        if(removeChecked.length > 0){
            dispatch(removeMarker(removeChecked))
            dispatch(removeSelectedOrders(removeChecked))
        }
    }, [checked])

    useEffect(() => {
        if(!areaExpanded){
            setChecked([])
        }
    }, [areaExpanded])

    return (
        <div className={classes.accordianSummaryStyle}>
            <Typography>{`${data.id}.${stripIdFromStaffName(data.name)}`} {props.showPhoneNumber? `[${data.phone}]`: null}</Typography>
            &nbsp;
            <Badge 
                color='error' 
                badgeContent={getOrderCount(data.order_count, data.route_planned_count)}
                max={99999}
                className={classes.badgeStyle}
            />
        </div>
    )

    function getOrderCount(orderCount = 0, plannedCount = 0){
        if (_.size(districtOrders) > 0){
            orderCount = _.reduce(districtOrders, (result, array, key) =>{
                return result + array.length
            }, 0)
        }
        if (orderCount === 0) return 0
        if (orderCount > 0 && plannedCount === 0) return orderCount
        if (orderCount > 0 && plannedCount > 0) return `${plannedCount}/${orderCount}`
        return 0
    }

    function filterDistrictOrders(staffOrders, filter){
        let result = {}
        _.forEach(staffOrders, (orders, key) => {
            result[key] = getFilteredOrders(orders, filter)
        })
        return result
    }

    function getFilteredOrders(orders, filter){
        if(!orders) return []
        if(!filter || filter.parcelStatus.length <= 0) return orders

        return _.filter(orders, (order)=>_.includes(filter.parcelStatus, order.path_info))
    }
}

SelectableOrderInfo.defaultProps = {
    showPhoneNumber: false,
    staffOrders: {},
    loading: false,
    areaExpanded: false
}

export default SelectableOrderInfo